import React from 'react'
import DocumentationTab from '../../components/sdk/DocumentationTab';
import Title from '../../components/Title';

const Documentation = () => {
  return ( <>
    <Title main={"SDK"} sub={"Documentation"}/>
    <DocumentationTab/>
  </> );
}

export default Documentation;